import React from "react";

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_rosalie-coach-ems/artifacts/w3ci2o8c_17792279867792214590735593949836.png";
const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_rosalie-coach-ems/artifacts/uy5va884_17792284387127564668919663721377.png";

// Dark/colored logo (formelec on transparent black bg) — for light backgrounds (header, admin)
// Native ratio ~1:1 (square)
export default function Logo({ size = "md", className = "", framed = true }) {
  const heights = {
    xs: "h-9",
    sm: "h-11",
    md: "h-14",
    lg: "h-20",
    xl: "h-28 sm:h-36 lg:h-44",
  };
  return (
    <img
      src={LOGO_DARK}
      alt="FORM'elec — Stimulez votre bien-être"
      width="500"
      height="500"
      className={`${heights[size] || heights.md} w-auto object-contain ${framed ? "rounded-2xl" : ""} ${className}`}
      style={{ maxWidth: "none" }}
    />
  );
}

// White + green logo PNG — for dark/hero backgrounds.
// Native ratio 600x180 = 3.33:1. We size by HEIGHT and let width auto.
export function LogoWhite({ size = "md", className = "" }) {
  const heights = {
    sm: "h-10",
    md: "h-14",
    lg: "h-20 sm:h-24",
    xl: "h-24 sm:h-32 lg:h-40",
  };
  return (
    <img
      src={LOGO_LIGHT}
      alt="FORM'elec"
      width="600"
      height="180"
      className={`${heights[size] || heights.md} w-auto object-contain ${className}`}
      style={{ maxWidth: "none", aspectRatio: "600 / 180" }}
    />
  );
}
